var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDotLineDone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 146,
    height: 2,
    viewBox: "0 0 146 2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_21701",
    "data-name": "\\uADF8\\uB8F9 21701",
    transform: "translate(-522 -371)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_221",
    "data-name": "\\uD0C0\\uC6D0 221",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(586 371)",
    fill: "#ff6a13"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1232",
    "data-name": "\\uD0C0\\uC6D0 1232",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(634 371)",
    fill: "#ff6a13"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_222",
    "data-name": "\\uD0C0\\uC6D0 222",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(594 371)",
    fill: "#ff6a13"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1233",
    "data-name": "\\uD0C0\\uC6D0 1233",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(642 371)",
    fill: "#ff6a13"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1238",
    "data-name": "\\uD0C0\\uC6D0 1238",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(650 371)",
    fill: "#ff6a13"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1239",
    "data-name": "\\uD0C0\\uC6D0 1239",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(658 371)",
    fill: "#ff6a13"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1240",
    "data-name": "\\uD0C0\\uC6D0 1240",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(666 371)",
    fill: "#ff6a13"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_220",
    "data-name": "\\uD0C0\\uC6D0 220",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(578 371)",
    fill: "#ff6a13"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1234",
    "data-name": "\\uD0C0\\uC6D0 1234",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(626 371)",
    fill: "#ff6a13"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_220-2",
    "data-name": "\\uD0C0\\uC6D0 220",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(570 371)",
    fill: "#ff6a13"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1235",
    "data-name": "\\uD0C0\\uC6D0 1235",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(618 371)",
    fill: "#ff6a13"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_220-3",
    "data-name": "\\uD0C0\\uC6D0 220",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(562 371)",
    fill: "#ff6a13"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1236",
    "data-name": "\\uD0C0\\uC6D0 1236",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(610 371)",
    fill: "#ff6a13"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_220-4",
    "data-name": "\\uD0C0\\uC6D0 220",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(554 371)",
    fill: "#ff6a13"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1237",
    "data-name": "\\uD0C0\\uC6D0 1237",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(602 371)",
    fill: "#ff6a13"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_220-5",
    "data-name": "\\uD0C0\\uC6D0 220",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(546 371)",
    fill: "#ff6a13"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_220-6",
    "data-name": "\\uD0C0\\uC6D0 220",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(538 371)",
    fill: "#ff6a13"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_220-7",
    "data-name": "\\uD0C0\\uC6D0 220",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(530 371)",
    fill: "#ff6a13"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_220-8",
    "data-name": "\\uD0C0\\uC6D0 220",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(522 371)",
    fill: "#ff6a13"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotLineDone);
export default __webpack_public_path__ + "static/media/DotLineDone.6931d9a55911ee47bb940ff08183bc86.svg";
export { ForwardRef as ReactComponent };